import { useEffect, useRef, useState } from "react";

export default function UseRequestAnimation() {
  const requestId = useRef<number>(0);
  const [status, setStatus] = useState<Date | null>(null);
  const [seconds, setSeconds] = useState<number | null>(null);
  const timeInterval = () => {
    const now = new Date();
    const nowTime = now?.getTime();
    const then = status?.getTime();
    const timeInSeconds = Math.floor(Math.abs(then - nowTime) / 1000);
    if (timeInSeconds >= 0) {
      setSeconds(() => timeInSeconds);
    }
    requestId.current = requestAnimationFrame(timeInterval);
  };

  useEffect(() => {
    requestId.current = requestAnimationFrame(timeInterval);
    return () => {
      cancelAnimationFrame(requestId?.current);
    };
  }, [status !== null]);

  const reset = () => {
    requestId.current = 0;
    setStatus(() => null);
    setSeconds(() => null);
  };

  return {
    seconds,
    status,
    setStatus,
    reset,
  };
}
